import { TextLabel } from '../TextLabel';
import {
	StyledContainer,
	StyledRightContainer,
} from './VehiclePlateBig.styled';

interface IVehiclePlateBigProps extends React.HTMLAttributes<HTMLDivElement> {
	number: string;
	region: string;
}

const VehiclePlateBig = ({ number, region }: IVehiclePlateBigProps) => {
	return (
		<StyledContainer>
			<TextLabel className={'number'}>
				<span style={{ fontSize: 12 }}>{number.slice(0, 1)}</span>
				<span style={{ fontSize: 16 }}>{number.slice(1, 4)}</span>
				<span style={{ fontSize: 12 }}>{number.slice(4, 6)}</span>
			</TextLabel>
			<div className="divider" />
			<StyledRightContainer>
				<TextLabel className={'region'}>{region}</TextLabel>
				<TextLabel className={'code'}>RUS</TextLabel>
			</StyledRightContainer>
		</StyledContainer>
	);
};

export { VehiclePlateBig };
